// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PathBreadCrumbs_wrapper__3_psO","condensedText":"PathBreadCrumbs_condensedText__1nMjY","dots":"PathBreadCrumbs_dots__EIt7t"};